import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import "./Login.css";
import Header from './Header';
import { KJUR } from 'jsrsasign';
import SHA256 from 'crypto-js/sha256';

const authJsonPath = process.env.REACT_APP_AUTH_JSON_PATH;
console.log(authJsonPath)

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
	const [authData, setAuthData] = useState(null);
    const navigate = useNavigate();

	useEffect(() => {
		fetch(`${authJsonPath}?r=${Math.random()}`)
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(data => {
				setAuthData(data)
			})
			.catch(error => {
				console.error('There was a problem with the fetch operation:', error);
			})
			.finally(() => {
				console.log('Fetch auth completed.');
		});
	}, []);


    const handleLogin = async (event) => {
        event.preventDefault();
		if (!password) {
			alert("Please enter a password.");
			return;
		}
		
		const header = { alg: 'HS256', typ: 'JWT' };
		const now = Math.floor(Date.now() / 1000);
		const expireTime = now + (8 * 3600); // Expires in 8 hour (8 * 3600 seconds)
		const secret = 'rurall-infragri__viewer'; // This should be kept secure
		const sHeader = JSON.stringify(header);
		const hashPassw = SHA256(password).toString();

		const userProfile = authData['users'][email];
		if (userProfile !== undefined) {
			if (userProfile.password === hashPassw) {
				const privileges = authData['roles'][userProfile.role] || [];
				const data = { userId: 99999, name: email, exp: expireTime, role: userProfile.role, privileges };
				const sData = JSON.stringify(data);

				try {
					const jwt = KJUR.jws.JWS.sign("HS256", sHeader, sData, { utf8: secret });
					localStorage.setItem('token', jwt);
				} catch (e) {
					console.error(e);
				}
				navigate("/viewer")
			} else {
				alert("Wrong user/password");
				return;
			}
		} else {
			alert("Wrong user/password");
			return;
		}
    };
	
	const fullHeightStyle = {
        minHeight: '100vh'
    };
	
	return (
		<Container fluid style={fullHeightStyle}>
			<Header/>
			<Row className="justify-content-md-center">
				<Col md={6}>
					<Form onSubmit={handleLogin}>
						<Form.Label style={{color:'#233D62'}}>Please Sign In to access page</Form.Label>
						<Form.Group className="mb-3">
							<Form.Control type="email" 
											onChange={(e) => setEmail(e.target.value)}
											placeholder="Enter email" />
						</Form.Group>

						<Form.Group className="mb-3" controlId="formBasicPassword">
							<Form.Control type="password" 
											autoComplete="true" 
											onChange={(e) => setPassword(e.target.value)} 
											placeholder="Password" />
						</Form.Group>

						<Button style={{width:'100%'}} variant="primary" type="submit">
							Login
						</Button>
					</Form>
				</Col>
			</Row>
		</Container>
	);
}

export default LoginPage;